import React from 'react';

const ProtectedPage = () => {
  return (
    <div>
      <h1>보호된 페이지</h1>
      <p>이 페이지는 로그인된 사용자만 접근할 수 있습니다.</p>
    </div>
  );
};

export default ProtectedPage;
